import {
  CardContent,
  Grid,
  ListItem,
  ListItemText,
  Typography,
  useEventCallback,
} from '@mui/material';
import { Fragment, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { PmiCard } from 'shell/components/shared/card';
import PmiTitle from 'shell/components/shared/title';
import Breadcrumbs from 'shell/components/shared/breadcrumb';
import { CommonCivilStatusCrumbs } from 'civil-status/constants/breadcrumb';
import { useActionAuthorization } from 'shell/hooks/use-action-authorization';
import {
  CivilStatusBirthUpload,
  CivilStatusDeathUpload,
  CivilStatusMarriageUpload,
  CivilStatusBirthSearch,
  CivilStatusDeathSearch,
  CivilStatusMarriageSearch,
  CivilStatusPrintFormula,
  CivilStatusStampCertificate,
  CivilStatusNotesText,
  CivilStatusDocumentRegistry,
  CivilStatusDocumentSerie,
  CivilUnionList,
  CivilStatusUnionCivilUpload,
  CitizenshipList,
  AnscBorn,
  AnscDeath,
  AnscMarriage,
  AnscUnion,
  AnscCitizenship,
  CivilStatusAuthorizations,
  AnscDomainManagement,
  AnscMunicipality,
  CivilStatusBirthplaces,
  AnscCommunication,
  AnscReport,
  AnscPec,
  AnscArchive,
  AnscResearchAct,
  AnscResearchActDraft,
  AnscResearchNotifications,
  AnscRegisterEmergency,
} from 'shell/authorizations/civil-status';
import SimaSubMenuNew from './sima-sub-menu-new';
import { useHttpClient } from 'shell/hooks/use-http-fetch/stateless';
import { __ACT_API_URL__ } from 'shell/constants/environment';
import { DataWizardAct } from 'civil-status/view-models/step-form';
import { HttpResponse } from 'shell/models/http-response';
import { ResponsePromise } from 'shell/hooks/use-http-fetch/stateless/type';
import { useUserProfile } from 'shell/hooks/use-user-profile';
import SubMenuTabelleDiServizio from './sub-menu-tabelle-di-servizio';
import { STATES_ACT } from 'civil-status/constants/states-act';
import { ID_REGISTER } from 'civil-status/components/shared/list-register';
import OtpButton from 'civil-status/components/shared/otp-button';
import NotificationSubMenu from './sub-menu-notifications';

const HomePage = (): React.ReactElement => {
  const navigate = useNavigate();

  const actions = useActionAuthorization({
    nascitaCaricamento: CivilStatusBirthUpload,
    morteCaricamento: CivilStatusDeathUpload,
    matrimonioCaricamento: CivilStatusMarriageUpload,
    unioneCivileCaricamento: CivilStatusUnionCivilUpload,
    nascitaRicerca: CivilStatusBirthSearch,
    morteRicerca: CivilStatusDeathSearch,
    matrimonioRicerca: CivilStatusMarriageSearch,
    formula: CivilStatusPrintFormula,
    timbro: CivilStatusStampCertificate,
    annotazioni: CivilStatusNotesText,
    documentiRegistro: CivilStatusDocumentRegistry,
    documentiSerie: CivilStatusDocumentSerie,
    ricercaUnioneCivile: CivilUnionList,
    ricercaCittadinanza: CitizenshipList,
    anscNascita: AnscBorn,
    anscMorte: AnscDeath,
    anscMatrimonio: AnscMarriage,
    anscUnione: AnscUnion,
    anscCittadinanza: AnscCitizenship,
    stampaCertificazione: [CivilStatusAuthorizations.StampaCertificazione],
    gestioneDominio: AnscDomainManagement,
    anscComuni: AnscMunicipality,
    anscBirthpalaces: CivilStatusBirthplaces,
    anscDomain: AnscDomainManagement,
    anscCommunication: AnscCommunication,
    anscReport: AnscReport,
    anscPec: AnscPec,
    anscArchive: AnscArchive,
    anscResearchAct: AnscResearchAct,
    anscResearchActDraft: AnscResearchActDraft,
    anscResearchNotifications: AnscResearchNotifications,
    anscRegisterEmergency: AnscRegisterEmergency,
  });

  const { userProfile } = useUserProfile();

  const featureSIMA13 = userProfile.datiLogin?.profile?.feature?.sipoWeb;

  const [simaSubmenuAnchorNascita, setSimaSubmenuAnchorNascita] = useState<null | HTMLElement>(
    null
  );
  const isSimaSubmenuAnchorSubmenuVisibleNascita = Boolean(simaSubmenuAnchorNascita);

  const handleSimaMenuClickNascita = (event: React.MouseEvent<HTMLElement>) => {
    event.preventDefault();
    event.stopPropagation();
    event.nativeEvent.stopImmediatePropagation();
    setSimaSubmenuAnchorNascita(event.currentTarget);
  };

  const handleSimaSubmenuCloseNascita = useEventCallback((event: React.MouseEvent) => {
    event.preventDefault();
    event.stopPropagation();
    event.nativeEvent.stopImmediatePropagation();
    setSimaSubmenuAnchorNascita(null);
  });

  const [simaSubmenuAnchorMorte, setSimaSubmenuAnchorMorte] = useState<null | HTMLElement>(null);
  const isSimaSubmenuAnchorSubmenuVisibleMorte = Boolean(simaSubmenuAnchorMorte);

  const handleSimaMenuClickMorte = (event: React.MouseEvent<HTMLElement>) => {
    event.preventDefault();
    event.stopPropagation();
    event.nativeEvent.stopImmediatePropagation();
    setSimaSubmenuAnchorMorte(event.currentTarget);
  };

  const handleSimaSubmenuCloseMorte = useEventCallback((event: React.MouseEvent) => {
    event.preventDefault();
    event.stopPropagation();
    event.nativeEvent.stopImmediatePropagation();
    setSimaSubmenuAnchorMorte(null);
  });

  const [simaSubmenuAnchorMatrimonio, setSimaSubmenuAnchorMatrimonio] =
    useState<null | HTMLElement>(null);
  const isSimaSubmenuAnchorSubmenuVisibleMatrimonio = Boolean(simaSubmenuAnchorMatrimonio);

  const handleSimaMenuClickMatrimonio = (event: React.MouseEvent<HTMLElement>) => {
    event.preventDefault();
    event.stopPropagation();
    event.nativeEvent.stopImmediatePropagation();
    setSimaSubmenuAnchorMatrimonio(event.currentTarget);
  };

  const handleSimaSubmenuCloseMatrimonio = useEventCallback((event: React.MouseEvent) => {
    event.preventDefault();
    event.stopPropagation();
    event.nativeEvent.stopImmediatePropagation();
    setSimaSubmenuAnchorMatrimonio(null);
  });

  const [simaSubmenuAnchorUnione, setSimaSubmenuAnchorUnione] = useState<null | HTMLElement>(null);
  const isSimaSubmenuAnchorSubmenuVisibleUnione = Boolean(simaSubmenuAnchorUnione);

  const handleSimaMenuClickUnione = (event: React.MouseEvent<HTMLElement>) => {
    event.preventDefault();
    event.stopPropagation();
    event.nativeEvent.stopImmediatePropagation();
    setSimaSubmenuAnchorUnione(event.currentTarget);
  };

  const handleSimaSubmenuCloseUnione = useEventCallback((event: React.MouseEvent) => {
    event.preventDefault();
    event.stopPropagation();
    event.nativeEvent.stopImmediatePropagation();
    setSimaSubmenuAnchorUnione(null);
  });

  // Menù sima cittadinanza
  const [simaSubmenuAnchorCittadinanza, setSimaSubmenuAnchorCittadinanza] =
    useState<null | HTMLElement>(null);

  const isSimaSubmenuAnchorSubmenuVisibleCittadinanza = Boolean(simaSubmenuAnchorCittadinanza);

  // Menù tabelle di servizio
  const [subMenuAnchorTabelleDiServizio, setSubmenuAnchorTabelleDiServizio] =
    useState<null | HTMLElement>(null);

  const isSubmenuAnchorVisibleTabelleDiServizio = Boolean(subMenuAnchorTabelleDiServizio);

  // Menù notifiche
  const [notificationAnchor, setNotificationAnchor] = useState<null | HTMLElement>(null);

  const isNotificationAnchorVisible = Boolean(notificationAnchor);

  /**
   * Gestisce l'evento di click sul men  tabelle di servizio, memorizzando l'elemento
   * che ha generato l'evento, in modo da ancorare il men  a esso.
   * @param {React.MouseEvent<HTMLElement>} event Evento di click generato dall'utente
   */
  const handleMenuClickTabelleDiServizio = useEventCallback(
    (event: React.MouseEvent<HTMLElement>) => {
      event.preventDefault();
      event.stopPropagation();
      event.nativeEvent.stopImmediatePropagation();
      setSubmenuAnchorTabelleDiServizio(event.currentTarget);
    }
  );

  /**
   * Gestisce l'evento di click sul men  notifiche, memorizzando l'elemento
   * che ha generato l'evento, in modo da ancorare il men  a esso.
   * @param {React.MouseEvent<HTMLElement>} event Evento di click generato dall'utente
   */
  const handleMenuClickNotifications = useEventCallback((event: React.MouseEvent<HTMLElement>) => {
    event.preventDefault();
    event.stopPropagation();
    event.nativeEvent.stopImmediatePropagation();
    setNotificationAnchor(event.currentTarget);
  });

  /**
   * Handles the event of closing the "notifiche" menu.
   * Prevents the default action, stops event propagation, and removes
   * the anchor element to hide the submenu.
   *
   * @param {React.MouseEvent} event The mouse event triggered by the user.
   */
  const handleMenuCloseNotifications = useEventCallback((event: React.MouseEvent) => {
    event.preventDefault();
    event.stopPropagation();
    event.nativeEvent.stopImmediatePropagation();
    setNotificationAnchor(null);
  });

  /**
   * Handles the event of closing the "tabelle di servizio" menu.
   * Prevents the default action, stops event propagation, and removes
   * the anchor element to hide the submenu.
   *
   * @param {React.MouseEvent} event The mouse event triggered by the user.
   */
  const handleMenuCloseTabelleDiServizio = useEventCallback((event: React.MouseEvent) => {
    event.preventDefault();
    event.stopPropagation();
    event.nativeEvent.stopImmediatePropagation();
    setSubmenuAnchorTabelleDiServizio(null);
  });

  /**
   * Handles the event of click on the "Sima Cittadinanza" menu,
   * memorizing the element that generated the event, in order to
   * anchor the menu to it.
   *
   * @param {React.MouseEvent<HTMLElement>} event Evento di click generato dall'utente
   */
  const handleSimaMenuClickCittadinanza = useEventCallback(
    (event: React.MouseEvent<HTMLElement>) => {
      event.preventDefault();
      event.stopPropagation();
      event.nativeEvent.stopImmediatePropagation();
      setSimaSubmenuAnchorCittadinanza(event.currentTarget);
    }
  );

  /**
   * Handles the event of closing the "Sima Cittadinanza" submenu.
   * Prevents the default action, stops event propagation, and removes
   * the anchor element to hide the submenu.
   *
   * @param {React.MouseEvent} event The mouse event triggered by the user.
   */
  const handleSimaSubmenuCloseCittadinanza = useEventCallback((event: React.MouseEvent) => {
    event.preventDefault();
    event.stopPropagation();
    event.nativeEvent.stopImmediatePropagation();
    setSimaSubmenuAnchorCittadinanza(null);
  });

  const saveData = useHttpClient(`${__ACT_API_URL__}/wizard/save`, {
    options: {
      method: 'POST',
      loading: true,
      errorCatching: true,
    },
  });

  /**
   * Handles the event of creating a new instance of the given wizard step.
   *
   * @param {string} name The name of the wizard step.
   * @param {string} step The step of the wizard.
   */
  const onClickNuovo = useEventCallback((name: string, step: string) => {
    const data: DataWizardAct = {
      questionarioEvento: [
        {
          key: {
            numProgressivoStep: 1,
          },
          cdStepSuccessivo: step || undefined,
          codStep: ' ',
          descBreveDomanda: 'Evento',
          descBreveRisposta: name || undefined,
        },
      ],
      statoCivile: {
        // tipoEvento: name || undefined,
        tipoEvento: step || undefined,
        codiceStatoEvento: STATES_ACT.ID_STATE_BOZZA,
      },
      evento: {
        // tipoEvento: name || undefined,
        tipoEvento: step || undefined,
        codiceStatoEvento: STATES_ACT.ID_STATE_BOZZA,
      },
    };

    (
      saveData({
        data,
      }) as unknown as ResponsePromise<HttpResponse<DataWizardAct>>
    ).then((response) => {
      const castedResponse = response?.data?.payload as DataWizardAct;
      const idEvento = castedResponse?.statoCivile?.key?.idEvento;

      navigate(`/stato-civile/${name}/${step}/nuovo/${idEvento}`);
    });
  });

  /**
   * Handles the event of click on the "Ricerca Icaro" button.
   * Navigates to the page for searching Icaro records.
   * @param {string} name The name of the wizard step.
   * @param {string} step The step of the wizard.
   */
  const onClickIcaro = useEventCallback((name: string, step: string) => {
    navigate(`/stato-civile/${name}/${step}/ricerca-icaro`);
  });

  /**
   * Handles the event of click on the "Ricerca Comunicazioni" button.
   * Navigates to the page for searching comunicazioni records.
   * @param {string} name The name of the wizard step.
   * @param {string} step The step of the wizard.
   */
  const onClickComunicazioni = useEventCallback((name: string, step: string) => {
    navigate(`/stato-civile/ricerca-comunicazioni/${name}/${step}`);
  });

  /**
   * Handles the event of click on the "Ricerca Comunicazioni Lista" button.
   * Navigates to the page for searching comunicazioni records from a list.
   *
   * @param {string} name The name of the wizard step.
   * @param {string} step The step of the wizard.
   */
  const onClickComunicazioniLista = useEventCallback((name: string, step: string) => {
    navigate(`/stato-civile/ricerca-comunicazioni-da-lista/${name}/${step}`);
  });

  /**
   * Handles the event of click on the "Ricerca Reportistica" button.
   * Navigates to the page for searching reportistica records.
   *
   * @param {string} name The name of the wizard step.
   * @param {string} step The step of the wizard.
   */
  const onClickReportistica = useEventCallback((name: string, step: string) => {
    navigate(`/stato-civile/ricerca-reportistica/${name}/${step}`);
  });

  /**
   * Handles the event of click on the "Ricerca Notifiche" button.
   * Navigates to the page for searching notifiche records.
   *
   * @param {string} name The name of the wizard step.
   * @param {string} step The step of the wizard.
   */
  // const onClickNotifiche = useEventCallback((name: string, step: string) => {
  //   navigate(`/stato-civile/notifiche/ansc/ricerca/${name}/${step}`);
  // });

  /**
   * Handles the event of click on the "Ricerca Registrazione SC" button.
   * Navigates to the page for searching registrazione SC records.
   *
   * @param {string} step The step of the wizard.
   */
  const onClickRegistrazioneSC = useEventCallback((step: string) => {
    navigate(`/stato-civile/notifiche-da-stato-civile/${step}`);
  });

  const gestioneTabelleSistema = userProfile.datiLogin?.profile?.feature?.sistema;

  return (
    <Fragment>
      <Breadcrumbs items={CommonCivilStatusCrumbs} />
      <Grid container spacing={2} padding="0" margin="0">
        <Grid item xs={12} md={6} padding="0" margin="0">
          <PmiTitle title="Stato Civile" paddingBottom={1} />
          <div className="pmi-mb-4">
            <Typography component="div" fontSize=".9rem" color="primary">
              {"Seleziona l'area su cui iniziare ad operare"}
            </Typography>
          </div>
        </Grid>
        <Grid item xs={12} md={6} padding="0" margin="0">
          <div className="pmi-mb-4">
            <OtpButton marginButton="1.5rem 0 1rem 0" />
          </div>
        </Grid>
      </Grid>
      <Grid container spacing={2}>
        {actions.annotazioni ||
        actions.documentiRegistro ||
        actions.documentiSerie ||
        actions.formula ||
        actions.matrimonioCaricamento ||
        actions.matrimonioRicerca ||
        actions.morteCaricamento ||
        actions.morteRicerca ||
        actions.nascitaCaricamento ||
        actions.nascitaRicerca ||
        actions.ricercaCittadinanza ||
        actions.ricercaUnioneCivile ||
        actions.timbro ||
        actions.unioneCivileCaricamento ||
        featureSIMA13 === '2' ||
        featureSIMA13 === '3' ? (
          <Grid item xs={12} md={4}>
            <Link to="/stato-civile/SIMA" className="pmi-anchor">
              <PmiCard>
                <CardContent>
                  <ListItem>
                    <ListItemText primary="Ricerca Atti SIMA" />
                  </ListItem>
                </CardContent>
              </PmiCard>
            </Link>
          </Grid>
        ) : undefined}
        {actions.anscResearchAct ? (
          <Grid item xs={12} md={4}>
            <Link to="/stato-civile/ricerca-atti" className="pmi-anchor">
              <PmiCard>
                <CardContent>
                  <ListItem>
                    <ListItemText primary="Ricerca Atti ANSC" />
                  </ListItem>
                </CardContent>
              </PmiCard>
            </Link>
          </Grid>
        ) : undefined}
        {actions.anscResearchNotifications ? (
          <Grid item xs={12} md={4}>
            <PmiCard onClick={handleMenuClickNotifications}>
              <CardContent>
                <NotificationSubMenu
                  onClick={handleMenuClickNotifications}
                  onClose={handleMenuCloseNotifications}
                  submenuAnchor={notificationAnchor}
                  isSubmenuVisible={isNotificationAnchorVisible}
                />
              </CardContent>
            </PmiCard>
          </Grid>
        ) : undefined}
        {actions.anscNascita ? (
          <Grid item xs={12} md={4}>
            <PmiCard onClick={handleSimaMenuClickNascita}>
              <CardContent>
                <SimaSubMenuNew
                  value="Nascita"
                  isSubmenuVisible={isSimaSubmenuAnchorSubmenuVisibleNascita}
                  onClick={handleSimaMenuClickNascita}
                  onClose={handleSimaSubmenuCloseNascita}
                  submenuAnchor={simaSubmenuAnchorNascita}
                  onClickNuovo={() => onClickNuovo('Nascita', ID_REGISTER.NASCITA)}
                  onClickIcaro={() => onClickIcaro('Nascita', ID_REGISTER.NASCITA)}
                  onClickRicerca={() =>
                    navigate(`/stato-civile/Nascita/${ID_REGISTER.NASCITA}/ricerca`)
                  }
                  onClickRicercaSima={() => navigate(`/stato-civile/nascita/ricerca`)} // ricerca in SIMA
                  anscCommunication={actions.anscCommunication}
                  onClickComunicazioniLista={() =>
                    onClickComunicazioniLista('Nascita', ID_REGISTER.NASCITA)
                  }
                  onClickComunicazioni={() => onClickComunicazioni('Nascita', ID_REGISTER.NASCITA)}
                  onClickRegistrationSC={() => onClickRegistrazioneSC(ID_REGISTER.NASCITA)}
                  anscReport={actions.anscReport}
                  onClickReportistica={() => onClickReportistica('Nascita', ID_REGISTER.NASCITA)}
                  onClickAnnotazioni={() =>
                    navigate(`/stato-civile/Nascita/${ID_REGISTER.NASCITA}/annotazioni`)
                  }
                  onClickRichiestaNumero={() =>
                    navigate(`/stato-civile/Nascita/${ID_REGISTER.NASCITA}/richiesta-numero`)
                  }
                  onClickRicercaNumero={() =>
                    navigate(`/stato-civile/Nascita/${ID_REGISTER.NASCITA}/ricerca-numero`)
                  }
                />
              </CardContent>
            </PmiCard>
          </Grid>
        ) : undefined}
        {actions.anscMorte ? (
          <Grid item xs={12} md={4}>
            <PmiCard onClick={handleSimaMenuClickMorte}>
              <CardContent>
                <SimaSubMenuNew
                  value="Morte"
                  isSubmenuVisible={isSimaSubmenuAnchorSubmenuVisibleMorte}
                  onClick={handleSimaMenuClickMorte}
                  onClose={handleSimaSubmenuCloseMorte}
                  submenuAnchor={simaSubmenuAnchorMorte}
                  onClickNuovo={() => onClickNuovo('Morte', ID_REGISTER.MORTE)}
                  withoutIcaro
                  onClickRicerca={() =>
                    navigate(`/stato-civile/Morte/${ID_REGISTER.MORTE}/ricerca`)
                  }
                  onClickRicercaSima={() => navigate(`/stato-civile/morte/ricerca`)} // ricerca in SIMA
                  anscCommunication={actions.anscCommunication}
                  onClickComunicazioni={() => onClickComunicazioni('Morte', ID_REGISTER.MORTE)}
                  onClickComunicazioniLista={() =>
                    onClickComunicazioniLista('Morte', ID_REGISTER.MORTE)
                  }
                  onClickRegistrationSC={() => onClickRegistrazioneSC(ID_REGISTER.MORTE)}
                  anscReport={actions.anscReport}
                  onClickReportistica={() => onClickReportistica('Morte', ID_REGISTER.MORTE)}
                  onClickAnnotazioni={() =>
                    navigate(`/stato-civile/Morte/${ID_REGISTER.MORTE}/annotazioni`)
                  }
                  onClickRichiestaNumero={() =>
                    navigate(`/stato-civile/Morte/${ID_REGISTER.MORTE}/richiesta-numero`)
                  }
                  onClickRicercaNumero={() =>
                    navigate(`/stato-civile/Morte/${ID_REGISTER.MORTE}/ricerca-numero`)
                  }
                />
              </CardContent>
            </PmiCard>
          </Grid>
        ) : undefined}
        {actions.anscMatrimonio ? (
          <Grid item xs={12} md={4}>
            <PmiCard onClick={handleSimaMenuClickMatrimonio}>
              <CardContent>
                <SimaSubMenuNew
                  value="Matrimonio"
                  isSubmenuVisible={isSimaSubmenuAnchorSubmenuVisibleMatrimonio}
                  onClick={handleSimaMenuClickMatrimonio}
                  onClose={handleSimaSubmenuCloseMatrimonio}
                  submenuAnchor={simaSubmenuAnchorMatrimonio}
                  onClickNuovo={() => onClickNuovo('Matrimonio', ID_REGISTER.MATRIMONIO)}
                  withoutIcaro
                  onClickRicerca={() =>
                    navigate(`/stato-civile/Matrimonio/${ID_REGISTER.MATRIMONIO}/ricerca`)
                  }
                  onClickRicercaSima={() => navigate(`/stato-civile/matrimonio/ricerca`)} // ricerca in SIMA
                  anscCommunication={actions.anscCommunication}
                  onClickComunicazioni={() =>
                    onClickComunicazioni('Matrimonio', ID_REGISTER.MATRIMONIO)
                  }
                  onClickComunicazioniLista={() =>
                    onClickComunicazioniLista('Matrimono', ID_REGISTER.MATRIMONIO)
                  }
                  onClickRegistrationSC={() => onClickRegistrazioneSC(ID_REGISTER.MATRIMONIO)}
                  anscReport={actions.anscReport}
                  onClickReportistica={() =>
                    onClickReportistica('Matrimonio', ID_REGISTER.MATRIMONIO)
                  }
                  onClickAnnotazioni={() =>
                    navigate(`/stato-civile/Matrimonio/${ID_REGISTER.MATRIMONIO}/annotazioni`)
                  }
                  onClickRichiestaNumero={() =>
                    navigate(`/stato-civile/Matrimonio/${ID_REGISTER.MATRIMONIO}/richiesta-numero`)
                  }
                  onClickRicercaNumero={() =>
                    navigate(`/stato-civile/Matrimonio/${ID_REGISTER.MATRIMONIO}/ricerca-numero`)
                  }
                />
              </CardContent>
            </PmiCard>
          </Grid>
        ) : undefined}
        {actions.anscUnione ? (
          <Grid item xs={12} md={4}>
            <PmiCard onClick={handleSimaMenuClickUnione}>
              <CardContent>
                <SimaSubMenuNew
                  value="Unione Civile"
                  isSubmenuVisible={isSimaSubmenuAnchorSubmenuVisibleUnione}
                  onClick={handleSimaMenuClickUnione}
                  onClose={handleSimaSubmenuCloseUnione}
                  submenuAnchor={simaSubmenuAnchorUnione}
                  onClickNuovo={() => onClickNuovo('Unione Civile', ID_REGISTER.UNIONE_CIVILE)}
                  withoutIcaro
                  onClickRicerca={() =>
                    navigate(`/stato-civile/Unione Civile/${ID_REGISTER.UNIONE_CIVILE}/ricerca`)
                  }
                  onClickRicercaSima={() => navigate(`/stato-civile/unione-civile/ricerca`)} // ricerca in SIMA
                  anscCommunication={actions.anscCommunication}
                  onClickComunicazioni={() =>
                    onClickComunicazioni('Unione Civile', ID_REGISTER.UNIONE_CIVILE)
                  }
                  onClickComunicazioniLista={() =>
                    onClickComunicazioniLista('Unione Civile', ID_REGISTER.UNIONE_CIVILE)
                  }
                  onClickRegistrationSC={() => onClickRegistrazioneSC(ID_REGISTER.UNIONE_CIVILE)}
                  anscReport={actions.anscReport}
                  onClickReportistica={() =>
                    onClickReportistica('Unione Civile', ID_REGISTER.UNIONE_CIVILE)
                  }
                  onClickAnnotazioni={() =>
                    navigate(`/stato-civile/Unione Civile/${ID_REGISTER.UNIONE_CIVILE}/annotazioni`)
                  }
                  onClickRichiestaNumero={() =>
                    navigate(
                      `/stato-civile/Unione Civile/${ID_REGISTER.UNIONE_CIVILE}/richiesta-numero`
                    )
                  }
                  onClickRicercaNumero={() =>
                    navigate(
                      `/stato-civile/Unione Civile/${ID_REGISTER.UNIONE_CIVILE}/ricerca-numero`
                    )
                  }
                />
              </CardContent>
            </PmiCard>
          </Grid>
        ) : undefined}
        {actions.anscCittadinanza ? (
          <Grid item xs={12} md={4}>
            <PmiCard onClick={handleSimaMenuClickCittadinanza}>
              <CardContent>
                <SimaSubMenuNew
                  value="Cittadinanza"
                  isSubmenuVisible={isSimaSubmenuAnchorSubmenuVisibleCittadinanza}
                  onClick={handleSimaMenuClickCittadinanza}
                  onClose={handleSimaSubmenuCloseCittadinanza}
                  submenuAnchor={simaSubmenuAnchorCittadinanza}
                  onClickNuovo={() => onClickNuovo('Cittadinanza', ID_REGISTER.CITTADINANZA)}
                  withoutIcaro
                  onClickRicerca={() =>
                    navigate(`/stato-civile/Cittadinanza/${ID_REGISTER.CITTADINANZA}/ricerca`)
                  }
                  onClickRicercaSima={() => navigate(`/stato-civile/cittadinanza/ricerca`)} // ricerca in SIMA
                  anscCommunication={actions.anscCommunication}
                  onClickComunicazioni={() =>
                    onClickComunicazioni('Cittadinanza', ID_REGISTER.CITTADINANZA)
                  }
                  onClickComunicazioniLista={() =>
                    onClickComunicazioniLista('Cittadinanza', ID_REGISTER.CITTADINANZA)
                  }
                  onClickRegistrationSC={() => onClickRegistrazioneSC(ID_REGISTER.CITTADINANZA)}
                  anscReport={actions.anscReport}
                  onClickReportistica={() =>
                    onClickReportistica('Cittadinanza', ID_REGISTER.CITTADINANZA)
                  }
                  onClickAnnotazioni={() =>
                    navigate(`/stato-civile/Cittadinanza/${ID_REGISTER.CITTADINANZA}/annotazioni`)
                  }
                  onClickRichiestaNumero={() =>
                    navigate(
                      `/stato-civile/Cittadinanza/${ID_REGISTER.CITTADINANZA}/richiesta-numero`
                    )
                  }
                  onClickRicercaNumero={() =>
                    navigate(
                      `/stato-civile/Cittadinanza/${ID_REGISTER.CITTADINANZA}/ricerca-numero`
                    )
                  }
                />
              </CardContent>
            </PmiCard>
          </Grid>
        ) : undefined}
        {actions.anscResearchActDraft ? (
          <Grid item xs={12} md={4}>
            <Link to="/stato-civile/ricerca-atto-da-compilare" className="pmi-anchor">
              <PmiCard>
                <CardContent>
                  <ListItem>
                    <ListItemText primary="Ricerca atto da completare" />
                  </ListItem>
                </CardContent>
              </PmiCard>
            </Link>
          </Grid>
        ) : undefined}
        {actions.anscRegisterEmergency ? (
          <Grid item xs={12} md={4}>
            <Link to="/stato-civile/recupero-atti-emergenza" className="pmi-anchor">
              <PmiCard>
                <CardContent>
                  <ListItem>
                    <ListItemText primary="Recupero Atti Registro di emergenza" />
                  </ListItem>
                </CardContent>
              </PmiCard>
            </Link>
          </Grid>
        ) : undefined}
        {/* {actions.stampaCertificazione && (featureSIMA13 === '1' || featureSIMA13 === '3') ? (
          <Grid item xs={12} md={4}>
            <Link to="/stato-civile/certificazione-ansc" className="pmi-anchor">
              <PmiCard>
                <CardContent>
                  <ListItem>
                    <ListItemText primary="Certificazione Stato Civile ANSC" />
                  </ListItem>
                </CardContent>
              </PmiCard>
            </Link>
          </Grid>
        ) : undefined} */}
        {(actions.anscBirthpalaces || actions.anscComuni || actions.anscDomain) &&
        gestioneTabelleSistema === '1' ? (
          <Grid item xs={12} md={4}>
            <PmiCard onClick={handleMenuClickTabelleDiServizio}>
              <CardContent>
                <SubMenuTabelleDiServizio
                  value="Tabelle di servizio"
                  isSubmenuVisible={isSubmenuAnchorVisibleTabelleDiServizio}
                  onClick={handleMenuClickTabelleDiServizio}
                  onClose={handleMenuCloseTabelleDiServizio}
                  onClickGestioneDomini={() => navigate('/stato-civile/ricerca-dominio')}
                  onClickGestioneComuni={() => navigate('/stato-civile/ricerca-comune')}
                  onClickGestioneLuoghiNascita={() => navigate('/stato-civile/luogo-nascita')}
                  onClickGestioneLuoghiDecesso={() => navigate('/stato-civile/luogo-decesso')}
                  onClickGestioneAutoritaDecesso={() => navigate('/stato-civile/autorita-decesso')}
                  onClickGestioneCultiReligiosi={() => navigate('/stato-civile/culti-religiosi')}
                  onClickGestioneMinistri={() => navigate('/stato-civile/ministro-culto')}
                  submenuAnchor={subMenuAnchorTabelleDiServizio}
                  withMunicipality={actions.anscComuni}
                  withDomain={actions.anscDomain}
                  withBirthpalaces={actions.anscBirthpalaces}
                />
              </CardContent>
            </PmiCard>
          </Grid>
        ) : undefined}
        {actions.anscPec ? (
          <Grid item xs={12} md={4}>
            <Link to="/stato-civile/gestione-pec" className="pmi-anchor">
              <PmiCard>
                <CardContent>
                  <ListItem>
                    <ListItemText primary="Gestione PEC" />
                  </ListItem>
                </CardContent>
              </PmiCard>
            </Link>
          </Grid>
        ) : undefined}
        {actions.anscArchive ? (
          <Grid item xs={12} md={4}>
            <Link to="/stato-civile/annotazioni-archivio" className="pmi-anchor">
              <PmiCard>
                <CardContent>
                  <ListItem>
                    <ListItemText primary="Annotazioni archivio" />
                  </ListItem>
                </CardContent>
              </PmiCard>
            </Link>
          </Grid>
        ) : undefined}
      </Grid>
    </Fragment>
  );
};

HomePage.displayName = 'home page component';

export default HomePage;
